import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";

export const usePublishNow = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id }: { id: string }) => api.drafts.publishNow(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["drafts"] });
      qc.invalidateQueries({ queryKey: ["scheduled"] });
      qc.invalidateQueries({ queryKey: ["published"] });
    },
  });
};
